module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg10-6ab622ccfbc5c2b9c2e5e567c71cc441.png";